const MainLayout = ({ children }) => {
  return children;
};

export default MainLayout;
